import { GREEN_PRIMRY, WHITE } from "../../utils/const";
import { convertNumbers } from "../../utils/ConvertNumbers";

const Item = (props) => {
  const defaultStyle = {
    paddingRight: "10px",
    paddingLeft: "10px",
    paddingTop: "4px",
    paddingBottom: "4px",
    border: "1px solid #333333",
    minWidth: "12px",
    textAlign: "center",
    cursor: "pointer",
  };

  if (props.selected) {
    defaultStyle.color = WHITE;
    defaultStyle.backgroundColor = GREEN_PRIMRY;
  }

  const itemClicked = () => {
    props.selectedChanged(props.number);
  };

  if (props.number === 0) {
    return (
      <div style={defaultStyle}>
        <span>.....</span>
      </div>
    );
  }

  return (
    <div style={defaultStyle} onClick={itemClicked}>
      <span>{convertNumbers(props.number)}</span>
    </div>
  );
};

export default Item;
